import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { PLAINTIFF_FIRM_REPORT_QUERY } from '../../../graphql.js'
import ResultsGrid from '../ResultsGrid.js'
import ParameterValues from '../ParameterValues.js'
import '../Custom.css'
import LargeRowHandler from '../LargeRowHandler.js'

const PLAINTIFF_FIRM_REPORT = gql(PLAINTIFF_FIRM_REPORT_QUERY)

export default function PlaintiffFirmReport({ location }) {
  console.log('PlaintiffFirmReport rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, PLAINTIFF_FIRM_REPORT, 'plaintiffFirmReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const resultRows = ResultsGrid(results, 0)
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('BosSci/plaintiffFirmReport/plaintiff_firm_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={'Plaintiff Firm Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}